import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const Divider = styled.div`
  width: 45px;
  height: 6px;
  background-color: #000000;
  margin-bottom: 16px;
`

export const Title = styled.h1`
  font-size: 36px;
  line-height: 44px;
  font-weight: 300;
  margin-bottom: 55px;
`

export const FormGroup = styled.form`
  display: flex;
  flex-direction: column;
`

export const Button = styled.button.attrs(({ type }) => ({
  type: type || 'button',
}))`
  background-color: #060606;
  border: 1px solid #060606;
  color: #ffffff;
  font-size: 14px;
  line-height: 22px;
  padding: 17px 34px;
  cursor: pointer;
  letter-spacing: 2px;
  text-transform: uppercase;

  &:disabled {
    opacity: 0.6;
  }
`

export const Line = styled.div`
  background-color: #d9d9d9;
  width: 100%;
  height: 1px;
  margin: 38px 0;
`

export const TextLink = styled(Link)`
  font-size: 16px;
  line-height: 19px;
  font-weight: 700;
  color: #000000;
  text-decoration: none;
`

export const TextWrapper = styled.div`
  font-size: 16px;
  line-height: 19px;
  font-weight: 400;
  color: #000000;
  text-decoration: none;
  margin-top: 12px;
`

export const CheckWrapper = styled.div`
  margin-bottom: 32px;
`
